<template>
  <div
    id="home-hero"
    class="container-fluid"
  >
    <div v-if="isNestleHome" class="nestleHero">
      <img src="@/assets/youpaq-logo-home.png" />
      <span>by</span>
      <img src="@/assets/youpaq-nestle-logo-home.png" class="shopLogo" />
    </div>
    <img v-else src="@/assets/youpaq-logo-home.png" />

    <h1 v-if="isNestleHome" class="nestleSlogan">{{ $t('home.sloganNestle') }}</h1>
    <h1 v-else>{{ $t('home.slogan') }}</h1>
  </div>
</template>

<script>
export default {
  name: 'HomeHero',
  computed: {
    isNestleHome() {
      return this.$route.name === 'homenestle'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit SCSS to this component only -->
<style lang="scss" scoped>
@import '../../assets/styles/youpaq.scss';

#home-hero {
  background: url('~@/assets/home-hero-bg-mobile.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  @include media-breakpoint-up(lg) {
    min-height: 850px;
    background: url('~@/assets/home-hero-bg-2.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }

  img {
    width: 80%;
    max-width: 450px;
    padding-top: 40px;

    @include media-breakpoint-up(md) {
      width: 90%;
      padding-top: 100px;
    }
  }

  h1 {
    font-size: 20px;
    font-weight: 600;
    width: 90%;
    color: white;
    max-width: 550px;
    padding: 20px 0;
    margin: 0;

    @include media-breakpoint-up(md) {
      font-size: 30px;
      width: 70%;
      font-weight: 500;
      padding: 30px 0;
    }
  }

  .nestleHero {
    width: 55%;

    img {
      width: 80%;
      padding-top: 20px;
      @include media-breakpoint-up(md) {
        width: 40%;
      }
    }

    span {
      font-weight: 900;
      color: white;
      font-size: 20px;
      display: block;
      padding: 20px 30px;

      @include media-breakpoint-up(md) {
        display: inline-block;
        padding: 0 30px;
      }
    }

    .shopLogo {
      background: white;
      border-radius: 12px;
      padding: 10px;
    }
  }

  .nestleSlogan {
    max-width: 90%;
    @include media-breakpoint-up(md) {
      max-width: 70%;
    }
  }
}
</style>
